import gql from 'graphql-tag'

export default gql`
  query suitabilityState {
    storedQuestions @client {
      questionId
      answerId
      questionPath
      page
      flowType
    }
    recommendation @client
    coreSuitabilityQuestions @client {
      text
      id
      key
      possibleAnswers {
        id
        key
        text
      }
    }
    showCoreSuitabilityQuestions @client
    page @client
    showNextButton @client
  }
`
